<template>
	<div id="marketstudies-index"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :realestatesOpen="realestatesOpen"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Real_estates_index') }}</h1>
					<vue-tabs>
						<v-tab :title="realestates_index_text">
							<div class="tab_content">
								<div>
									<div @click.prevent="onCreateNewRealEstate"
										 style="width: fit-content; margin-left: auto">
										<icon-button icon="plus-circle" :text="new_real_estate_button_text"
													 icon_color="black"
													 text_color="black" border_color="lightgray"></icon-button>
									</div>
								</div>

								<div class="grid-row" layout="row top-stretch">
									<div class="grid-cell" layout="row">
										<input type="text" :placeholder="filter_placeholder" self="size-x1"
											   v-model="realestate_table.filter"
											   data-intro="You can filter the data in a datatable by typing in any of the filter fields"
											   data-step="9" data-position="top">
									</div>
								</div>
								<div class="grid-row" layout="row top-stretch">
									<div class="grid-cell">
										<paginator :source="_.orderBy(object_to_array(realestates), ['date_modified'], ['desc'])" :page-size="50"
												   :filter="realestate_table.filter"
												   data-intro="Use the paginator to page data for easier viewing"
												   data-step="50"
												   data-position="top">
											<template scope="page">
												<datatable id="data-table-main"
														   :source="page.data"
														   :filterable="false"
														   :striped="realestate_table.striped"
														   :editable="realestate_table.editable"
														   :line-numbers="realestate_table.lineNumbers">
													<datatable-column
															v-for="column in realestate_table.columns"
															:id="column.id"
															:label="column.label"
															:width="column.width"
															:sortable="column.sortable"
															:groupable="column.groupable"
															:formatter="column.formatter">
													</datatable-column>
													<datatable-column id="actions" label="Actions" :sortable="false"
																	  :groupable="false"></datatable-column>
													<template slot="address" scope="cell">
														<div>
															<span class="navspan"
																  @click.prevent="editRealEstate(cell.row)">
																<span v-if="cell.row['street_name']">{{ cell.row['street_name']
																	}}</span><span
																	v-if="cell.row['street_number']">, {{ cell.row['street_number']
																}}</span><span
																	v-if="cell.row['floor']">, {{ cell.row['floor']
																}}</span><span
																	v-if="cell.row['door']">-{{ cell.row['door']
																}}</span><span
																	v-if="cell.row['staircase']">, esc. {{ cell.row['staircase']
																}}</span><span
																	v-if="cell.row['block']">, blo. {{ cell.row['block']
																}}</span><span
																	v-if="cell.row['postal_code']">, {{ cell.row['postal_code']
																}}</span><span
																	v-if="cell.row['municipality']">, {{ cell.row['municipality'].name_ine
																}}</span>
															</span>
														</div>
													</template>

													<template slot="appraisalfiles" scope="cell">
														<div>
															<!-- this.$router.push({name: 'appraisalfile-editor', query: {id: key}}) -->
															<span v-for="(val, key) in cell.row['appraisalfiles']">
																<span class="navspan"
																	  @click.prevent="goToFile(key)">{{ val }}</span>
															</span>
														</div>

													</template>
													<template slot="actions" scope="cell">
														<a @click="editRealEstate(cell.row)"
														   style="margin-right: 2rem; cursor: pointer;">
															<icon name="pencil" scale="1" color="gray"></icon>
														</a>
														<!--
														<a @click="deleteAppraisalFile(cell.row)" style="cursor: pointer;">
															<icon name="trash-o" scale="1" color="gray"></icon>
														</a>
														-->
													</template>
												</datatable>
											</template>
										</paginator>
									</div>
								</div>

							</div>
						</v-tab>

					</vue-tabs>


					<!--<bar>
					</bar>
-->
				</div>
			</div>
		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'realestates-index',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            realestatesOpen: false,
            realestateOpen: false,
            editabletrue: true,
            error: null,
            success_message: null,
            queryComparableTypeValue: null,
            new_real_estate_button_text: Vue.i18n.translate('Add_real_estate'),
            add_realestate_text: Vue.i18n.translate('Add_real_estate'),
            query_realestates_text: Vue.i18n.translate('Query_real_estates'),
            realestates_index_text: Vue.i18n.translate('Real_estates_index'),
            realestates_text: Vue.i18n.translate('Real_estates'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            lat_lng_error_text: Vue.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            realestate_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'address',
                        label: Vue.i18n.translate('Address'),
                        width: 40,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'appraisalfiles',
                        label: Vue.i18n.translate('Files'),
                        width: 10,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    /*
					{
						id: 'street_number',
						label: Vue.i18n.translate('Street_number'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'floor',
						label: Vue.i18n.translate('Floor'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'door',
						label: Vue.i18n.translate('door'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'postal_code',
						label: Vue.i18n.translate('Postal_code'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'municipality',
						label: Vue.i18n.translate('Municipality'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					*/
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: 18,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            },

        }),

        created () {
            this.FETCH_REALESTATES({path: 'realestates'})
                .then(() => {
                    this.master_loading = false

                })
        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'realestates'
            ])
        },

        methods: {
            ...mapActions(
                [
                    'CREATE_NEW_REALESTATE',
                    'FETCH_REALESTATES',
                    'RESET_REALESTATE',
                    'SET_REALESTATE',
                    'SET_APPRAISALFILE'
                ]),
            onCreateNewRealEstate: function () {
                // console.log('hey')
                // console.log('realestate: ')
                // console.log(this.realestate)
                this.RESET_REALESTATE().then((res) => {
                    this.CREATE_NEW_REALESTATE({
                        report_id: null,
                        file_id: null,
                        file_number: null,
                        report_number: null,
                        report_version: null,
                        path: 'realestates' + '/',
                        parent_path: null
                    }).then((res) => {
                        this.$router.push({name: 'realestate-editor', query: {id: res.key}})
                    })
                })
            },
            editRealEstate: function (entity) {
                // console.log('edit realestate...')
                this.SET_REALESTATE({path: 'realestates' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'realestate-editor', query: {id: entity.id}})

                })
            },
            goToFile (key) {
                this.SET_APPRAISALFILE({path: 'appraisalfiles' + '/' + key}).then((res) => {
                    this.$router.push({name: 'appraisalfile-editor', query: {id: key}})

                })
            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Real Estates'
            }

        }
    }
</script>


// WEBPACK FOOTER //
// RealEstatesIndex.vue?2047b816